// Preview-only tab branding. Decided from the runtime hostname, so a shared
// build deployed to production keeps the default "Strata" title + favicon.
const PREVIEW_HOSTS = (process.env.REACT_APP_PREVIEW_HOSTS || "")
  .split(",").map((h) => h.trim().toLowerCase()).filter(Boolean);

export const isPreviewHost = (host = window.location.hostname) => PREVIEW_HOSTS.includes(host.toLowerCase());

const FAVICON = "data:image/svg+xml," + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="10" fill="#FACC15"/>' +
  '<text x="32" y="47" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="46" font-weight="900" fill="#111827">S</text></svg>',
);
const TITLE = "Strata-Preview";

export function applyEnvironmentBranding() {
  if (!isPreviewHost()) return;
  const setIcons = () => {
    document.querySelectorAll('link[rel~="icon"], link[rel="apple-touch-icon"]').forEach((l) => {
      if (l.href !== FAVICON) { l.type = "image/svg+xml"; l.href = FAVICON; }
    });
  };
  const setTitle = () => { if (document.title !== TITLE) document.title = TITLE; };
  setIcons(); setTitle();
  // Re-assert if anything (route changes, libraries) rewrites the head.
  new MutationObserver(() => { setTitle(); setIcons(); }).observe(document.head, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["href"] });
}
